"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _colors = _interopRequireDefault(require("../../constants/colors"));

var _vars = _interopRequireDefault(require("../../constants/vars"));

var _reactGa = require("react-ga");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n\tcursor: ", ";\n\topacity: 0 !important;\n\tposition: absolute;\n\ttop: 0;\n\tleft: 0;\n\tright: 0;\n\tbottom: 0;\n\twidth: 100%;\n\theight: 100%;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n\tposition: relative;\n\ttext-align: left;\n\tborder: 1px solid\n\t\t", ";\n\tbackground: ", ";\n\t", ";\n\tborder-radius: ", ";\n\theight: 100%;\n\topacity: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

var Option = _styledComponents.default.div(_templateObject(), function (props) {
  return props.selected ? _colors.default.primaryLight : _colors.default.borderColor;
}, function (props) {
  return props.selected ? _colors.default.primaryLighter : '#fff';
}, function (props) {
  return props.selected && "box-shadow: 1px 4px 8px -4px #888888";
}, _vars.default.borderRadius, function (props) {
  return props.disabled ? '0.3' : 1;
});

Option.displayName = 'Option';

var Radio = _styledComponents.default.input(_templateObject2(), function (props) {
  return props.disabled ? 'not-allowed' : 'pointer';
});

Radio.displayName = 'Radio';

var RadioBlock =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(RadioBlock, _React$Component);

  function RadioBlock() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = RadioBlock.prototype;

  _proto.componentDidMount = function componentDidMount() {
    var _this$props = this.props,
        _this$props$GA = _this$props.GA,
        category = _this$props$GA.category,
        action = _this$props$GA.action,
        checked = _this$props.checked;

    if (category && action && checked) {
      var defaultAction = "Defaulted to " + action;
      (0, _reactGa.event)({
        category: category,
        action: defaultAction
      });
    }
  };

  _proto.render = function render() {
    var _this$props2 = this.props,
        checked = _this$props2.checked,
        disabled = _this$props2.disabled,
        _onChange = _this$props2.onChange,
        name = _this$props2.name,
        value = _this$props2.value,
        children = _this$props2.children,
        className = _this$props2.className,
        _this$props2$GA = _this$props2.GA,
        category = _this$props2$GA.category,
        action = _this$props2$GA.action,
        props = _objectWithoutPropertiesLoose(_this$props2, ["checked", "disabled", "onChange", "name", "value", "children", "className", "GA"]);

    return _react.default.createElement(Option, {
      "data-testid": "option",
      selected: checked,
      disabled: disabled,
      className: className
    }, children, _react.default.createElement(Radio, _extends({
      type: "radio",
      name: name,
      value: value,
      checked: checked,
      disabled: disabled,
      onChange: function onChange(evt) {
        if (category && action && !checked) {
          var defaultAction = "Switched to " + action;
          (0, _reactGa.event)({
            category: category,
            action: defaultAction
          });
        }

        _onChange(evt);
      }
    }, props)));
  };

  return RadioBlock;
}(_react.default.Component);

RadioBlock.propTypes = {
  checked: _propTypes.bool.isRequired,
  disabled: _propTypes.bool,
  onChange: _propTypes.func.isRequired,
  name: _propTypes.string.isRequired,
  value: _propTypes.string.isRequired,
  children: _propTypes.node.isRequired,
  className: _propTypes.string,
  GA: (0, _propTypes.shape)({
    category: _propTypes.string,
    action: _propTypes.string
  })
};
RadioBlock.defaultProps = {
  className: '',
  disabled: false,
  GA: {}
};
var _default = RadioBlock;
exports.default = _default;